<script setup lang="ts">
import { computed } from 'vue';
import { statusTone, type StatusTone } from '@/components/DataTable/statusChips';

/**
 * A status as a chip: a coloured dot and the word, for example "● Offline".
 * The colour comes from the word, unless a `tone` is given.
 */
const props = defineProps<{ word: string; tone?: StatusTone }>();

const DOT_CLASS = {
    good: 'bg-emerald-500',
    bad: 'bg-red-500',
    pending: 'bg-amber-400',
    neutral: 'bg-muted-foreground/60',
} as const;

const dotClass = computed(() => DOT_CLASS[props.tone ?? statusTone(props.word)]);
</script>

<template>
  <span
    data-testid="status-chip"
    class="inline-flex h-6 max-w-full items-center gap-1.5 rounded-full bg-muted px-2 text-xs text-foreground"
  >
    <span class="size-2 shrink-0 rounded-full" :class="dotClass" aria-hidden="true" />
    <span class="truncate">{{ word }}</span>
  </span>
</template>
